module.exports = __webpack_public_path__ + "static/media/destinoAccesible.187b79cc.png";